// Lightweight confirmation guard for destructive admin actions.
// Returns true if the admin confirms the removal.
export function confirmRemove(what = "this item") {
  return window.confirm(`Remove ${what}? This action cannot be undone.`);
}
